import { useContext, React, useEffect } from "react";
import { UserContext } from "../context/UserContext";
import { LoaderContext } from "../context/LoaderContext";
import { useNavigate } from "react-router-dom";

export default function SecureRoute() {
  const { user, loginUser } = useContext(UserContext);
  const { hideloader } = useContext(LoaderContext);
  const router = useNavigate();
  useEffect(() => {
    if (user == null) {
      hideloader();
      router("/");
    }
  }, []);
}
